<template>
  <div>
    <PageHeader :title="tituloPagina" />
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <span class="mb-2" v-html="textoInicial"></span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="tabela">
      <div>
        <div class="card">
          <div class="card-body">
            <div>
              <b-table responsive="sm" :items="dadosContatos" :fields="camposContatos" per-page="1000" striped>
                <template #cell(options)="data">
                  <div class="d-flex justify-content-end">
                    <b-button size="sm" class="me-1" variant="primary" @click="editarContato(data.item)"
                      data-tooltip="Editar" data-tooltip-location="left">
                      <i class="mdi mdi-pencil"></i>
                    </b-button>
                    <b-button size="sm" class="me-1" :disabled="data.item.st_principal == 'S'" variant="danger"
                      @click="excluirContato(data.item)" data-tooltip="Excluir" data-tooltip-location="left">
                      <i class="mdi mdi-trash-can"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div>
              <div class="mt-1 d-flex justify-content-end gap-4">
                <b-button variant="info" class="mt-5 mb-3" @click="incluir()">
                  <i class="mdi mdi-plus"></i>
                  Incluir
                </b-button>
                <b-button variant="success" class="mt-5 mb-3" :disabled="disabledSalvar" @click="salvarContato"
                  data-tooltip="Salvar" data-tooltip-location="bottom">
                  + Salvar
                  <b-spinner variant="primary" small class="ms-2" v-if="loadingSalvar"></b-spinner>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div :class="selectCdTipo.cd_tipo == 6 ? 'col-md-3' : 'col-md-6'">
              <b-form-group class="mb-3" label="Tipo de contato">
                <multiselect v-model="selectCdTipo" placeholder="Selecione" :show-labels="false" label="nm_tipo"
                  :options="optionCdTipo" @input="updateStPrincipal" />
              </b-form-group>
            </div>
            <div :class="selectCdTipo.cd_tipo == 6 ? 'col-md-3' : 'col-md-6'">
              <b-form-group class="mb-3" label="Telefone">
                <b-form-input v-mask="mascaraTelefone(telefone)" v-model="telefone" type="text" trim
                  autocomplete="off"></b-form-input>
              </b-form-group>
            </div>
            <div class="row col-md-6" v-if="selectCdTipo.cd_tipo == 6">
              <div class="col-md-6">
                <b-form-group class="mb-3" label="O que o contato é seu?">
                  <multiselect v-model="selectGrauContato" placeholder="Selecione" :show-labels="false"
                    label="nm_contato" :options="optionGrauContato" />
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group class="mb-3" label="Nome Contato Recado">
                  <b-form-input v-model="nomeContato" type="text" trim autocomplete="off" maxlength="60"></b-form-input>
                </b-form-group>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="m-auto">
              <b-form-checkbox v-model="stPrincipal" unchecked-value="N" value="S" plain
                :disabled="disabledPrincipal || selectCdTipo.cd_tipo == 6">
                Contato Principal
              </b-form-checkbox>
            </div>
          </div>
          <div class="row">
            <div class="mt-1 d-flex justify-content-between">
              <b-button variant="secondary" data-tooltip="Voltar" data-tooltip-location="bottom" class="mt-1 me-1"
                @click="tabela = !tabela; limparCampos()">
                <i class="mdi mdi-arrow-left-circle font-size-15"></i>
              </b-button>
              <b-button variant="success" class="mt-1 me-1" :disabled="disabledSalvar" @click="salvar"
                data-tooltip="Salvar" data-tooltip-location="bottom">
                + Salvar
                <b-spinner variant="primary" small class="ms-2" v-if="loadingSalvar"></b-spinner>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">

    </div>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";

const capitalizeString = (str) => {
  return str
    .split(" ")
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};
export default {
  components: {
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      tituloPagina: 'ATUALIZAÇÃO CADASTRAL',
      textoInicial: 'Cooperado(a)!<br> Verificamos que suas informações de contato e referências estão desatualizadas. <br>Por favor, atualize seu número de telefone e forneça no mínimo mais três contatos do tipo "Recado". Esses contatos serão utilizados pela Cooperativa para tomada de decisões em situações críticas e de emergência. <br>É importante que essas pessoas estejam aptas a tomar decisões e tenham conhecimento de sua rotina ou contato próximo com seus familiares.<br /> Além dos contatos familiares (Pai, mãe, irmã(o), esposo(a)), um dos contatos deve ser registrado como não familiar (Amigo(a), Conhecido(a) ou Vizinho(a)).', telefone: "",
      sqTelefone: "",
      nomeContato: "",
      sqContato: "",
      cdTipo: "",
      optionGrauContato: [],
      optionCdTipo: [],
      selectGrauContato: null,
      selectCdTipo: "",
      stPrincipal: "N",
      tabela: true,
      dadosCadastrais: null,
      dadosContatos: [],
      camposContatos: [
        {
          key: "nr_telefone",
          label: "Telefone",
          formatter: (value, row, column) => {
            const ddd = `(${column.nr_ddd}) `;
            const telefoneFormatado = value.replace(/(\d{4})(\d{4})$/, '$1-$2');
            return ddd + telefoneFormatado;
          },
        },
        {
          key: "cd_tipo",
          label: "Tipo",
          formatter: (value) => {
            var cdTipo = this.optionCdTipo.find((el) => el.cd_tipo == value);
            return cdTipo ? cdTipo.nm_tipo : "";
          },
        },
        {
          key: "sq_contato_recado",
          label: "Relação",
          formatter: (value) => {
            var sqContato = this.optionGrauContato.find(
              (el) => el.sq_contato_recado == value
            );
            return sqContato ? sqContato.nm_contato : "";
          },
        },
        {
          key: "nm_contato_recado",
          label: "Nome Recado",
          formatter: (value) => {
            if (value) {
              if (value.length > 12) {
                return value.substring(0, 12) + "...";
              } else {
                return value;
              }
            } else {
              return "";
            }
          },
        },
        {
          key: "st_principal",
          label: "Principal",
          formatter: (value) => {
            return value == "S" ? "Sim" : "Não";
          },
        },
        {
          key: "options",
          label: "",

        },
        {
          key: 'tornePrincipal',
          label: "",
        },
      ],
      disabledSalvar: false,
      loadingSalvar: false,
      loading: true,
      disabledPrincipal: false,
    };
  },
  async created() {
    await this.buscarContatos();
    // await this.verificarSituacaoCadastral()
  },
  methods: {
    async verificarSituacaoCadastral() {
      try {
        const respData = await this.$http.get("api/cadastroCandidato/consultaContatos");
        if (respData.data.status == 500) {
          this.$store.commit("TEL_EMERGENCIA", true);
          this.$router.push("/");
        }

        this.dadosCadastrais = respData.data.dados;
        const telEmergenciaFlag = localStorage.getItem("validacao-tel-recados");
        if (respData.data.validacao === 'V' && !telEmergenciaFlag || respData.data.status == 500) {
          this.$store.commit("TEL_EMERGENCIA", true);
          this.$router.push("/");
        } else {
          this.$store.commit("TEL_EMERGENCIA", false);
          localStorage.setItem("validacao-tel-recados", 'false');
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.error === "Nenhum registro encontrado") {
          this.$store.commit("TEL_EMERGENCIA", true);
          this.$router.push("/");
        } else {
          console.error("Erro ao consultar contatos:", error);
        }
      }
      
    },
    async buscarContatos() {
      this.loading = true;
      try {
        const [telPessoaResponse, lkpRecadoResponse, lkpCdTipoResponse] =
          await Promise.all([
            this.$http.get("api/cadastroCandidato/buscarContatos"),
            this.$http.get("api/cadastroCandidato/buscarLkpContatoRecado"),
            this.$http.get("api/cadastroCandidato/buscarTipoContato"),
          ]);

        this.optionCdTipo = lkpCdTipoResponse.data.map((item) => ({
          ...item,
          nm_tipo: capitalizeString(item.nm_tipo),
        }));
        this.dadosContatos = telPessoaResponse.data;
        this.optionGrauContato = lkpRecadoResponse.data;
      } catch (error) {
        console.error("Erro ao buscar os contatos:", error);
      } finally {
        this.loading = false;
        this.tabela = true;
      }
    },
    mascaraTelefone(telefone) {
      const tiraMask = telefone.replace(/\D/g, "");
      return tiraMask.length === 11 ? "(##) #####-####" : "(##) ####-####";
    },
    exibirAlertaTresContatosRecado() {
      this.$tools.alerta('É necessário ter pelo menos 3 contatos do tipo <strong> "Recado"</strong>.', "warning");
    },
    async salvarContato() {

      try {
        const respData = await this.$http.get("api/cadastroCandidato/consultaContatos");
        console.log(respData.data.status);
        if (respData.data.status == 500) {
          this.$store.commit("TEL_EMERGENCIA", true);
          this.$router.push("/");
        }
        const contatosTipoRecado = this.dadosContatos.filter(contato => contato.cd_tipo == 6);
        const resultadosTipo6 = this.dadosContatos.filter(contato =>
          Number(contato.cd_tipo) === 6 && contato.st_principal.trim().toUpperCase() === 'N'
        );
        const contatoInvalido = contatosTipoRecado.some(contato =>
          contato.st_principal !== 'S' && (!contato.nm_contato_recado || !contato.sq_contato_recado)
        );
        if (resultadosTipo6.length < 3) {
          this.exibirAlertaTresContatosRecado();
          return;
        }

        if (contatoInvalido) {
          this.$tools.alerta('É necessário incluir a "Relação" e "Nome" para Contatos do Tipo Recado', "warning");
          return;
        }

        if (respData.data.dados.qtde_nao_familiar < 1) {
          this.$tools.alerta("É preciso ter no mínimo 1 contato de recado não familiar", "warning");
          return;
        }

        if (respData.data.dados.qtde_familiar < 1) {
          this.$tools.alerta("É preciso ter no mínimo 1 contato de recado familiar", "warning");
          return;
        }

        const contatoValido = this.dadosContatos.find(contato => contato.st_principal === 'N' && [3, 5, 8].includes(Number(contato.sq_contato_recado)));
        if (!contatoValido) {
          this.$tools.alertaContato('Por favor, <strong> atualize seu número de telefone e forneça três contatos do tipo "Recado" </strong>, sendo um deles registrado com a "Relação" não familiar: Amigo(a), Conhecido(a) ou Vizinho(a).', "warning");
          return;
        }

        const responseIncluirContato = await this.$http.post("api/cadastroCandidato/incluirContatoRecado", contatoValido);
        if (!responseIncluirContato) {
          this.$tools.alerta("Erro ao incluir o contato. Por favor, tente novamente.", "error");
          return;
        }

        localStorage.removeItem("validacao-tel-recados");

        this.$tools.alerta("Dados salvos com sucesso", "success");
        this.$emit("carregarNivelPerfil");
        this.$http.put("api/cadastroCandidato/atualizarTelefoneContato"),
        this.$store.commit("TEL_EMERGENCIA", true);
        this.$router.push("/");
      } catch (error) {
        const mensagem =
          error.response &&
          error.response.data &&
          error.response.data.error;

        if (mensagem === "Nenhum dado válido encontrado") {
          this.exibirAlertaTresContatosRecado();
          return;
        }

        if (mensagem === "Nenhum registro encontrado") {
          this.$store.commit("TEL_EMERGENCIA", true);
          this.$router.push("/");
          return;
        }

        console.error("Erro ao consultar contatos:", error);
      }
    },
    limparCampos() {
      this.selectGrauContato = null;
      this.nomeContato = null;
      this.nr_telefone = null;
    },
    salvar() {
      if (this.telefone == "" || this.selectCdTipo.cd_tipo == "") {
        this.$tools.alerta(
          "Por favor, para continuar preencha todos os campos",
          "warning"
        );
        return;
      }
      if (
        this.selectCdTipo.cd_tipo == 6 &&
        (!this.nomeContato || !this.selectGrauContato)
      ) {
        this.$tools.alerta(
          "Por favor, para continuar preencha todos os campos",
          "warning"
        );
        return;
      }
      this.loading = true;
      const numeros = this.telefone.replace(/\D/g, "");
      var item = {
        nr_ddd: numeros.substring(0, 2),
        nr_telefone: numeros.substring(2),
        st_principal: this.stPrincipal,
        sq_contato_recado: this.selectGrauContato && this.selectGrauContato.sq_contato_recado
          ? this.selectGrauContato.sq_contato_recado
          : null,
        nm_contato_recado: this.nomeContato,
        sq_telefone: this.sqTelefone,
        cd_tipo: this.selectCdTipo.cd_tipo,
      };
      this.$http
        .post("api/cadastroCandidato/incluirContatoRecado", item)
        .then(() => {
          this.$tools.alerta("Cadastrado com sucesso", "success");
          this.$emit("carregarNivelPerfil");
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.error === "Nenhum dado válido encontrado") {
            this.exibirAlertaTresContatosRecado();
            return;
          }
          this.$tools.alerta(err.response.data.message, "error");
        })
        .finally(() => {
          this.loading = false;
          this.buscarContatos();
          this.limparCampos();

        });
    },
    incluir() {
      this.telefone = "";
      this.selectGrauContato = "";
      this.stPrincipal = "N";
      this.nomeContato = "";
      this.selectCdTipo = "";
      this.sqTelefone = "";
      this.sq_contato_recado = null;
      this.nm_contato_recado = "";
      this.tabela = false;
      // this.disabledPrincipal = false;
    },
    editarContato(data) {
      var montaNumero = data.nr_ddd + data.nr_telefone;
      this.telefone = montaNumero;
      if (data.sq_contato_recado) {
        this.selectGrauContato = this.optionGrauContato.find(
          (el) => el.sq_contato_recado == data.sq_contato_recado
        );
        this.sq_contato_recado = data.sq_contato_recado;
      } else {
        this.sq_contato_recado = null;
      }
      this.selectCdTipo = this.optionCdTipo.find(
        (el) => el.cd_tipo == data.cd_tipo
      );
      this.nomeContato = data.nm_contato_recado;
      this.sqTelefone = data.sq_telefone;
      this.stPrincipal = data.st_principal;
      this.disabledPrincipal = this.stPrincipal == "S" ? true : false;
      this.tabela = false;
    },

    excluirContato(data) {
      this.loading = true;
      this.$http
        .post("api/cadastroCandidato/excluirContato", data)
        .then(() => {
          this.$tools.alerta("Excluído com sucesso", "success");
          this.$emit("carregarNivelPerfil");
        })
        .catch((err) => {
          this.$tools.alerta(err.response.data.message, "error");
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
          this.buscarContatos();
        });
    },
    updateStPrincipal() {
      if (this.selectCdTipo.cd_tipo == 6) {
        this.stPrincipal = "N";
      }
    },
    navegar(nomeAba, direcao) {
      this.$emit("navegar", nomeAba, direcao);
    },
  },
};
</script>